import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream p-8">
      <div className="w-full max-w-sm bg-white rounded-xl border border-border p-8">
        <Link to="/" className="flex items-center gap-2.5 mb-6">
          <img src="/brand/ofr-mark.png" alt="OFR" className="w-9 h-9 rounded-md object-cover" />
          <div className="font-heading font-bold text-forest">Our First Realty</div>
        </Link>
        <h1 className="font-heading font-extrabold text-2xl text-forest tracking-tight">Reset your password</h1>
        {done ? (
          <div data-testid="forgot-success" className="mt-4 rounded-lg bg-forest/5 border border-forest/20 p-4 text-sm text-forest">
            If <span className="font-medium">{email}</span> is registered, you'll receive a reset link within a minute. Check your inbox (and spam).
          </div>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mt-1 mb-6">Enter your account email and we'll send a reset link.</p>
            <form onSubmit={submit} data-testid="forgot-form" className="space-y-3">
              <div>
                <Label htmlFor="fp-email" className="text-xs">Email</Label>
                <Input id="fp-email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 bg-forest hover:bg-forest-hover text-white rounded-full">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <p className="text-sm text-muted-foreground mt-6 text-center">
          <Link to="/login" className="text-forest font-medium hover:text-gold-hover">← Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
